@if (components().length) {
@for (component of components(); track component) {
<ng-container *ngComponentOutlet="component"></ng-container>
}
} @else {
<!-- Reserves roughly the space the real sections will take before their
       chunks resolve, so the page doesn't jump from ~0 height to full height
       in one frame — that jump is what made the sticky header visibly snap
       right as landing/about-us finished loading. An approximation, not a
       per-slot measurement; it only needs to be in the right ballpark. -->
<div style="min-height: 100vh" aria-hidden="true"></div>
}